import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@awaze/design-system.components.text';
import { differenceInDays, formatISO } from 'date-fns';
import { CalendarDay } from './calendar-day';
import { CalendarContainer, StyledDayBox, StyledDayLabelBox, StyledMonth, StyledTextWrapper, } from './calendar-month.styles';
import { getActiveDays, getCalendarMonthLabel, getDayLabels, getDaysInMonth, getOffsetDays, isSameDate, } from './calendar.utils';
export const CalendarMonth = ({ startDate, duration, minDate, maxDate, month, firstWeekDay, locale, availability, monthsToShow, horizontal, onDayClick, onDayHover, hoveredDate, formatPrice, freeSelectionMode = false, }) => {
    const largeAmounts = availability &&
        Object.values(availability).some(({ price }) => price && formatPrice(price).length > 7);
    const offsetDays = getOffsetDays(month, firstWeekDay);
    const blanks = [...Array(offsetDays)].map((_, i) => (_jsx(StyledDayBox, { largeAmounts: largeAmounts }, `blank${i}`)));
    const numberOfDaysInMonth = getDaysInMonth(month);
    const activeRange = getActiveDays(startDate, duration, 'forwards');
    const isEndSelected = activeRange.length > 1;
    const isStartDateSelectionMode = !startDate || isEndSelected;
    let daysToHighlight = 1;
    if (!freeSelectionMode) {
        daysToHighlight = duration;
    }
    else if (!isStartDateSelectionMode) {
        daysToHighlight = differenceInDays(hoveredDate, startDate);
    }
    const hoveredRange = getActiveDays(hoveredDate, daysToHighlight, freeSelectionMode ? 'backwards' : 'forwards');
    const hoveredIsSameAsActive = isSameDate(hoveredDate, startDate);
    const daysInMonth = [...Array(numberOfDaysInMonth)].map((_, index) => {
        const date = new Date(month.getFullYear(), month.getMonth(), month.getDate() + index);
        const isActive = Boolean(activeRange.find((activeDate) => isSameDate(activeDate, date)));
        const isStartOfActiveRange = isSameDate(date, startDate);
        const isEndOfActiveRange = startDate &&
            isEndSelected &&
            isSameDate(activeRange[activeRange.length - 1], date);
        const isHovered = Boolean(hoveredRange.find((activeDate) => isSameDate(activeDate, date)));
        let isStartOfHoveredRange;
        if (freeSelectionMode) {
            isStartOfHoveredRange =
                !startDate || duration > 1 ? isSameDate(date, hoveredDate) : false;
        }
        else {
            isStartOfHoveredRange = isSameDate(date, hoveredDate);
        }
        const isEndOfHoveredRangeIndex = isStartDateSelectionMode
            ? hoveredRange.length - 1
            : hoveredRange.length;
        const isEndOfHoveredRange = freeSelectionMode
            ? isSameDate(date, hoveredDate)
            : isSameDate(hoveredRange[isEndOfHoveredRangeIndex], date);
        const availabilityProvided = availability
            ? Object.keys(availability).length !== 0
            : false;
        const formattedDate = formatISO(date, { representation: 'date' });
        const isUnselectable = !!(availabilityProvided && availability[formattedDate]?.isUnselectable);
        let minDateWithLimit = minDate;
        if (freeSelectionMode && startDate && duration === 1) {
            minDateWithLimit = startDate;
        }
        return (_jsx(CalendarDay, { date: date, minDate: minDateWithLimit, maxDate: maxDate, onDayClick: onDayClick, isActive: isActive, isUnselectable: isUnselectable, isStartOfActiveRange: isStartOfActiveRange, isEndOfActiveRange: isEndOfActiveRange, availability: availability, onDayHover: onDayHover, isHovered: !hoveredIsSameAsActive && isHovered, isStartOfHoveredRange: !hoveredIsSameAsActive && isStartOfHoveredRange, isEndOfHoveredRange: !hoveredIsSameAsActive && isEndOfHoveredRange, largeAmounts: largeAmounts, formatPrice: formatPrice }, `${month.getTime() + index}`));
    });
    const calendarMonthLabel = getCalendarMonthLabel(month, locale);
    const dayLabels = getDayLabels(firstWeekDay, locale);
    return (_jsxs(StyledMonth, { monthsToShow: monthsToShow, horizontal: horizontal, "data-testid": "calendar-month", children: [_jsx(StyledTextWrapper, { children: _jsx(Text, { type: "mid", mb: 16, sizes: 300, children: calendarMonthLabel }) }), _jsxs(CalendarContainer, { "data-testid": "calendar-container", children: [[...dayLabels].map((dayLabel) => (_jsx(StyledDayLabelBox, { largeAmounts: largeAmounts, children: dayLabel }, dayLabel))), [...blanks, ...daysInMonth].map((cell) => cell)] })] }));
};
//# sourceMappingURL=calendar-month.js.map